import React from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import BreadcrumbLink from "../../components/Common/BreadcrumbLink";
import IntegratedTraccarView from "../../components/TraccarMap/IntegratedTraccarView";

const ServicesMap = () => {
  const { t } = useTranslation();
  // Las credenciales ahora vienen del .env
  // Si estás en producción/STG, puedes pasar undefined para usar la sesión existente
  const email = import.meta.env.VITE_TRACCAR_USER;
  const password = import.meta.env.VITE_TRACCAR_PASSWORD;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadcrumbLink
          title={t("ControlTower")}
          link="/control-tower/services-map"
          breadcrumbItem={t("ControlTower")}
        />
        <div style={{ 
          height: 'calc(100vh - 200px)', 
          width: '100%',
          position: 'relative'
        }}>
          <IntegratedTraccarView 
            email={email}
            password={password}
          />
        </div>
      </Container>
    </div>
  );
};

export default ServicesMap;
